import Quill from "quill";
import { QUILL_FONT_WHITELIST } from "../constants";

const Font = Quill.import("formats/font") as any;
// Add your custom font names here.
Font.whitelist = QUILL_FONT_WHITELIST;
Quill.register(Font, true);
